import angular from 'angular';
import invoiceCreateComponent from './invoice-create.component';

let invoiceCreateModule = angular.module('invoiceCreate', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('invoiceCreate', invoiceCreateComponent);


export default invoiceCreateModule;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-create/invoice-create.js